/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptions_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_viewer">;
    readonly " $refType": "PdpSharedDescriptionAdditionalOptions_viewer";
};
export type PdpSharedDescriptionAdditionalOptions_viewer$data = PdpSharedDescriptionAdditionalOptions_viewer;
export type PdpSharedDescriptionAdditionalOptions_viewer$key = {
    readonly " $data"?: PdpSharedDescriptionAdditionalOptions_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptions_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptions_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'a9b9df2199ac342c794d8791e7f2bcb9';
export default node;
